import apiClient from './api';
import { Invoice } from '../types/invoice'; // تأكد من وجود هذا النوع
import {  InvoiceStatus, InvoiceType } from '../types/enums'; // تأكد من وجود هذا النوع
import { PagedResult, TableParams } from '../hooks/useServerSideTable';

// نوع بيانات لإنشاء فاتورة جديدة
export interface NewInvoiceData {
  type: InvoiceType;
  related_id: number;
  amount: number;
  due_date: string;
}

// نوع بيانات لتحديث فاتورة
export interface UpdateInvoiceData {
  amount?: number;
  due_date?: string;
  status?: InvoiceStatus;
  payment_date?: string | null;
}

/**
 * جلب قائمة الفواتير مع دعم للترقيم والبحث والفرز
 */
export const getPagedInvoices = async (params: TableParams): Promise<PagedResult<Invoice>> => {
  const response = await apiClient.get<{ data: PagedResult<Invoice> }>('/invoices/paged', { params });
  return response.data.data;
};

/**
 * جلب فاتورة بواسطة ID
 */
export const getInvoiceById = async (id: number): Promise<Invoice> => {
  const response = await apiClient.get<{ data: Invoice }>(`/invoices/${id}`);
  return response.data.data;
};

/**
 * إنشاء فاتورة جديدة
 */
export const createInvoice = async (invoiceData: NewInvoiceData): Promise<Invoice> => {
  const response = await apiClient.post<{ data: Invoice }>('/invoices', invoiceData);
  return response.data.data;
};

/**
 * تحديث فاتورة موجودة
 */
export const updateInvoice = async (id: number, invoiceData: UpdateInvoiceData): Promise<Invoice> => {
  const response = await apiClient.put<{ data: Invoice }>(`/invoices/${id}`, invoiceData);
  return response.data.data;
};

/**
 * حذف فاتورة بواسطة ID
 */
export const deleteInvoice = async (id: number): Promise<void> => {
  await apiClient.delete(`/invoices/${id}`);
};

/**
 * تحديث حالة الفاتورة إلى مدفوعة
 */
export const markInvoiceAsPaid = async (id: number): Promise<Invoice> => {
    const response = await apiClient.patch<{ data: Invoice }>(`/invoices/${id}/pay`);
    return response.data.data;
};

/**
 * [LAWYER] جلب الفواتير الخاصة بالمستخدم الحالي (المحامي)
 */
export const getMyInvoices = async (): Promise<Invoice[]> => {
  const response = await apiClient.get<{ data: Invoice[] }>('/invoices/my-invoices');
  return response.data.data;
};

